import { io } from 'socket.io-client';

const socket = io('https://tabliq-server-production.up.railway.app', {
  transports: ['websocket'],
  upgrade: false,
});

export default socket;